export enum EventTypeEnum {
  CalculationRun = 'CALCULATION_RUN',
  UserJoined = 'USER_JOINED',
  ClientQuestionnaireFinalized = 'CLIENT_QUESTIONNAIRE_FINALIZED',
}
